module.exports = __webpack_public_path__ + "static/media/usc_logo_2.e5722f09.png";